import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=312b698b&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=312b698b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312b698b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('312b698b')) {
      api.createRecord('312b698b', component.options)
    } else {
      api.reload('312b698b', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=312b698b&scoped=true&", function () {
      api.rerender('312b698b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22jpR9RB988h9/JS/comp/DocBox.vue"
export default component.exports